import { addDays, differenceInCalendarDays, format, parseISO } from 'date-fns'

export function safariItineraryTimeline(items) {
  const days = items.map((item, index) => ({ item, index })).filter(day => day.item.date)
    .sort((left, right) => left.item.date.localeCompare(right.item.date))
  if (!days.length) return []

  const firstDate = parseISO(days[0].item.date)
  const timeline = []
  days.forEach((day, position) => {
    if (position) {
      const previousDate = parseISO(days[position - 1].item.date)
      const missingCount = differenceInCalendarDays(parseISO(day.item.date), previousDate) - 1
      for (let offset = 1; offset <= missingCount; offset++) {
        const date = addDays(previousDate, offset)
        timeline.push({
          kind: 'missing',
          date: format(date, 'yyyy-MM-dd'),
          dayNumber: differenceInCalendarDays(date, firstDate) + 1,
        })
      }
    }
    timeline.push({
      kind: 'day',
      ...day,
      dayNumber: differenceInCalendarDays(parseISO(day.item.date), firstDate) + 1,
    })
  })
  return timeline
}

export function safariItineraryError(items) {
  if (!items.length) return 'Add at least one itinerary day.'
  if (items.some(item => !item.date)) return 'Add a date for every itinerary day.'
  const timeline = safariItineraryTimeline(items)
  const dates = items.map(item => item.date)
  if (new Set(dates).size !== dates.length) return 'Each itinerary date can appear only once.'
  if (timeline.some(day => day.kind === 'missing')) return 'Add a program for every missing day before saving.'
  return ''
}
